module.exports = __webpack_public_path__ + "static/media/Packiro.345b24d1.png";